<div class="treatment-plans-selection-modal">
  <gen-overlay-loader *ngIf="loading" class="treatment-plans-selection-overlay-loader"></gen-overlay-loader>
  <section class="selection-field-container">
    <dls-searchbox (search)="searchText = $event">
      <input dlsInput [ngModel]="searchText" (ngModelChange)="searchText=$event; onSearchTextChange($event);"
             [value]="searchText"
             placeholder="{{payload?.searchInput?.placeHolderText | translate}}">
    </dls-searchbox>
  </section>
  <section class="treatment-plans-table Auto_Treatment_Plans_Table">
    <p-table class="plans-table"
             [autoLayout]="true"
             [first]="pageChangeEvent.first"
             [paginator]="false"
             [resetPageOnSort]="false"
             [responsive]="true"
             [rowTrackBy]="rowTrackBy()"
             [rows]="iterationRows"
             [sortField]="sortBy"
             [sortOrder]="sortOrder"
             [scrollable]="true"
             [value]="list"
             styleClass="tune-table"
             [(selection)]="selectedRows"
             (onHeaderCheckboxToggle)="onHeaderBoxClick($event)">
      <ng-template pTemplate="header" *ngIf="payload.selectAllEnabled && !!payload.table">
        <tr>
          <th class="table-worklist-checkbox">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngFor="let item of payload.table;  let i = index"
              class="{{item.width|lowercase}}-column-width {{item.className}}"
              [pSortableColumn]="getSortColumn(item, sortKeys, i)">
            <span class="table-header-wrapper">
                        <span class="{{item.icon}}"></span>
                        <span>{{item.label|translate}}</span>
                        <ng-container *ngIf="item.sortable && getSortColumn(item, sortKeys, i)">
                            <p-sortIcon [field]="sortKeys[i]"></p-sortIcon>
                        </ng-container>
                    </span>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">
          <td class="table-worklist-checkbox">
            <p-tableCheckbox id="treatment-plans-worklist-checkbox" [value]="rowData"></p-tableCheckbox>
          </td>
          <td *ngFor="let item of payload.table; let i = index; let last = last"
              class="{{item.width|lowercase}}-column-width">
            <section class="column-data">
              <section *ngFor="let key of item.keys" class="inline-section">
                <!-- cycle by keys in table column -->
                <section class="column-wrapper" [ngClass]="[item.className || '']" [ngSwitch]="getItemType(item, key)">
                  <span *ngSwitchDefault class="column-text" [innerHTML]="getColumnData(item, key, rowData)"></span>
                  <div *ngSwitchCase="'icon'">
                    <span class="{{(getColumnData(item, key, rowData))}}"></span>
                  </div>
                </section>
              </section>
            </section>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="footer-content">
          <div class="entries-container">
            <span>{{"Entries per page" | translate}}:</span>
            <span class="entries-counter">{{iterationRows}}</span>
          </div>
          <div class="paginator-container">
            <p-paginator #customPaginator
                    [rows]="iterationRows"
                    [pageLinkSize]="0"
                    [first]="pageChangeEvent.first"
                    [totalRecords]="length"
                    (onPageChange)="paginate($event)"
            ></p-paginator>
            <div class="paginator-left">
              <button type="button" pRipple class="p-paginator-first p-paginator-element p-link"
                      (click)="customPaginator.changePageToFirst($event)"
                      [ngClass]="{'p-disabled':customPaginator.isFirstPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-double-left"></span>
              </button>
              <button type="button" pRipple class="p-paginator-prev p-paginator-element p-link"
                      (click)="customPaginator.changePageToPrev($event)"
                      [ngClass]="{'p-disabled':customPaginator.isFirstPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-left"></span>
              </button>
              <button type="button" pRipple class="p-paginator-next p-paginator-element p-link"
                      (click)="customPaginator.changePageToNext($event)"
                      [ngClass]="{'p-disabled':customPaginator.isLastPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-right"></span>
              </button>
              <button type="button" pRipple class="p-paginator-last p-paginator-element p-link"
                      (click)="customPaginator.changePageToLast($event)"
                      [ngClass]="{'p-disabled':customPaginator.isLastPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-double-right"></span>
              </button>
            </div>
            <span class="p-paginator-info">{{getPagingInfo()}}</span>
          </div>
        </div>
      </ng-template>
    </p-table>
  </section>
</div>
